(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.healed-ocean-cta-smooth-scroll');
    if (!link) return;

    var href = link.getAttribute('href');
    if (href && href.startsWith('#')) {
      var targetId = href.substring(1);
      var targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      // If there's no matching element on this page, don't preventDefault —
      // this lets a cross-page link like "/products/handle#healed-ocean-product"
      // navigate normally instead of doing nothing.
    }
  });

  // On landing (e.g. coming from the home page CTA), smooth-scroll to the
  // hash target instead of the browser's instant jump.
  function scrollToHashOnLoad() {
    if (!window.location.hash) return;
    var targetElement = document.getElementById(window.location.hash.substring(1));
    if (!targetElement) return;

    setTimeout(function () {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToHashOnLoad);
  } else {
    scrollToHashOnLoad();
  }
})();